import "./ProyectosCommon.css";
import { BasePageComponent } from "../../../shared/components/pages/BasePageComponent";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { CultivoService } from "../../services/proyectos/CultivoService";
import { CultivoDeleteService } from "../../services/proyectos/CultivoDeleteService";
import { CultivoFormModal } from "./CultivoFormModal";
import { ConfirmDialogComponent } from "../../../shared/components/ConfirmDialogComponent";
import { errorMessageComponent } from "../../../shared/components/error/ErrorMessageComponent";

export class CultivosPage extends BasePageComponent {
  private _all: CultivoResponse[] = [];
  private _filtered: CultivoResponse[] = [];
  private _tbody!:  HTMLTableSectionElement;
  private _totEl!:  HTMLSpanElement;
  private _search!: HTMLInputElement;

  public getAppRoute(): string { return "/proyectos/cultivos"; }
  public getPageTitle(): string | null { return "Proyectos"; }

  protected override renderPageContent(pageContent: HTMLDivElement): void {
    pageContent.className = "sx-page pr-page";
    pageContent.innerHTML = `
      <div class="pr-content">
        <div class="pr-pg-hd">
          <div>
            <div class="pr-pg-ey">Proyectos · Configuración</div>
            <div class="pr-pg-ti">Cultivos</div>
            <div class="pr-pg-su">Cultivos disponibles para crear proyectos. Cada uno tiene su propio catálogo de costos.</div>
          </div>
          <button class="sx-btn sx-btn-primary sx-btn-sm" id="cul-nuevo"><i class="ph ph-plus"></i> Nuevo cultivo</button>
        </div>

        <div class="pr-frow">
          <div class="pr-sw">
            <i class="ph ph-magnifying-glass" aria-hidden="true"></i>
            <input class="pr-si" id="cul-search" placeholder="Buscar cultivo…">
          </div>
          <span class="pr-ftot" id="cul-tot"></span>
        </div>

        <div class="pr-tbl-wrap">
          <table class="pr-tbl">
            <thead>
              <tr><th>Cultivo</th><th>Slug</th><th>Meses a cosecha</th><th>Acciones</th></tr>
            </thead>
            <tbody id="cul-tbody"><tr><td colspan="4" class="pr-empty">Cargando…</td></tr></tbody>
          </table>
        </div>
      </div>
    `;

    this._tbody  = document.getElementById("cul-tbody")! as HTMLTableSectionElement;
    this._totEl  = document.getElementById("cul-tot")!;
    this._search = document.getElementById("cul-search")! as HTMLInputElement;
    this._search.oninput = () => this._filterAndRender();
    document.getElementById("cul-nuevo")!.onclick = () => this._onCreate();

    void this._loadData();
  }

  protected override beforeDispose(): void {}

  private async _loadData(): Promise<void> {
    try {
      const items = await CultivoService.instance.get();
      this._all = items.filter((c) => !c.isEliminado).sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
    } catch (error) {
      errorMessageComponent.addError("Error al cargar cultivos", (error as Error).message);
      this._tbody.innerHTML = `<tr><td colspan="4" class="pr-empty">Error al cargar</td></tr>`;
    }
  }

  private _filterAndRender(): void {
    const q = this._search.value.toLowerCase().trim();
    this._filtered = this._all.filter((c) => !q || c.nombre.toLowerCase().includes(q));
    this._render();
  }

  private _render(): void {
    const list = this._filtered;
    this._totEl.textContent = `${list.length} cultivo${list.length === 1 ? "" : "s"}`;
    if (list.length === 0) {
      this._tbody.innerHTML = `<tr><td colspan="4" class="pr-empty">Sin resultados</td></tr>`;
      return;
    }
    this._tbody.innerHTML = list.map((c, i) => `
      <tr>
        <td style="font-weight:var(--sx-weight-semibold)">${this._esc(c.nombre)}</td>
        <td class="pr-num" style="color:var(--sx-text-tertiary)">${this._esc(c.slug)}</td>
        <td class="pr-num">${c.mesesACosecha} m</td>
        <td>
          <div class="pr-actions">
            <button class="sx-btn sx-btn-secondary sx-btn-sm" data-act="editar" data-idx="${i}">Editar</button>
            <button class="sx-btn sx-btn-ghost sx-btn-icon sx-btn-sm" data-act="eliminar" data-idx="${i}" title="Eliminar"><i class="ph ph-trash"></i></button>
          </div>
        </td>
      </tr>`).join("");

    this._tbody.querySelectorAll<HTMLButtonElement>("button[data-act]").forEach((btn) => {
      const c = list[Number(btn.dataset.idx)];
      btn.onclick = () => {
        if (btn.dataset.act === "editar")   this._onEdit(c);
        if (btn.dataset.act === "eliminar") this._onDelete(c);
      };
    });
  }

  private _onCreate(): void {
    new CultivoFormModal((saved) => {
      this._all = [saved, ...this._all].sort((a, b) => a.nombre.localeCompare(b.nombre));
      this._filterAndRender();
    }).init();
  }

  private _onEdit(c: CultivoResponse): void {
    new CultivoFormModal((saved) => {
      this._all = this._all.map((x) => (x.id === saved.id ? saved : x));
      this._filterAndRender();
    }, c).init();
  }

  private _onDelete(c: CultivoResponse): void {
    new ConfirmDialogComponent({
      title: "Eliminar cultivo",
      message: `¿Eliminar "${c.nombre}"? Solo se puede si no tiene ítems de catálogo ni proyectos creados.`,
      confirmLabel: "Eliminar",
      onConfirm: async () => {
        try {
          await new CultivoDeleteService().delete(c.id);
          this._all = this._all.filter((x) => x.id !== c.id);
          this._filterAndRender();
        } catch (error) {
          errorMessageComponent.addError("Error al eliminar", (error as Error).message);
        }
      },
    }).init();
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
}
